/**
 * Tracking degraded for long enough to be a finding (2026-10-21).
 *
 * A single degraded verdict is noise: people sweep the camera off the floor, or
 * point it at nothing just before tapping the X. Degraded counts only once it
 * has held CONTINUOUSLY for `thresholdMs` of session time; any healthy reading
 * restarts the clock. Fires once per detector — one per session.
 */
export function createSustainedDegradedDetector(
  thresholdMs: number,
): (degraded: boolean, sessionMs: number) => boolean {
  let degradedSince: number | null = null
  let fired = false
  return (degraded, sessionMs) => {
    if (fired) return false
    if (!degraded) {
      degradedSince = null
      return false
    }
    degradedSince ??= sessionMs
    if (sessionMs - degradedSince < thresholdMs) return false
    fired = true
    return true
  }
}

/** How long tracking must stay degraded, mid-session, before it is reported. */
export const SUSTAINED_DEGRADED_MS = 10_000
